import { Api } from '../api';
import {
  ConfigSummaryRequest,
  ConfigSummaryResponse,
  ConfigDetailsRequest,
  ConfigDetailsResponse,
  CreateConfigSettingsResponse,
  CreateConfigSettingsRequest,
  ConfigSchemaRequest,
  ConfigSchema,
  TemplateFilterRequest,
  consumptionReportRequest,
  ConsumptionMetricResponse,
  RefreshTemplateRequest,
  RefreshTemplateResponse,
  TemplateListResponse,
  ConfigModule,
  CreateShippingChargesRequest,
  GetShippingChargesListResponse,
  GetShippingChargesListRequest,
  GetShippingChargesByIdResponse,
  GetShippingChargesByIdRequest,
  DeleteShippingChargesRequest,
  UpdateSequenceOfShippingChargesRequest,
  UpdateAdvancePaymentResponse,
  UpdateAdvancePaymentRequest,
} from './model';

export const configApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    configSummary: builder.mutation<
      ConfigSummaryResponse[],
      ConfigSummaryRequest
    >({
      query(arg) {
        return {
          url: `configsettings/config/summary`,
          body: arg,
          method: 'POST',
        };
      },
    }),
    getConfigDetails: builder.query<
      ConfigDetailsResponse,
      ConfigDetailsRequest
    >({
      query(arg) {
        return {
          url: `configsettings/config`,
          params: arg,
          method: 'GET',
          cache: 'no-cache',
        };
      },
      transformResponse: (response: ConfigDetailsResponse) => {
        const config = response.config;
        const transformedConfig = Object.fromEntries(
          Object.entries(config).map(([key, value]) => [
            key,
            value === 'true' ? true : value === 'false' ? false : value,
          ])
        );
        return { ...response, config: transformedConfig };
      },
    }),
    createConfigSettings: builder.mutation<
      CreateConfigSettingsResponse,
      CreateConfigSettingsRequest
    >({
      query(arg) {
        return {
          url: `configsettings/create`,
          body: arg,
          method: 'POST',
        };
      },
    }),
    getConfigSchema: builder.query<ConfigSchema[], ConfigSchemaRequest>({
      query(arg) {
        return {
          url: `configsettings/schema/${arg.workspaceId}`,
          params: arg,
          method: 'GET',
        };
      },
    }),

    updateMMLite: builder.mutation<any, { sellerWorkspaceId: string }>({
      query(arg) {
        const { sellerWorkspaceId } = arg;
        return {
          url: `hub/orgs/api/whatsapp-config/internal/mmlite/prepare-broadcast/${sellerWorkspaceId}?sellerWorkspaceId=${sellerWorkspaceId}`,
          method: 'POST',
        };
      },
    }),

    // getTemplatList: builder.query<any, any>({
    //   query(arg) {
    //     const { templateId, payload } = arg;
    //     return {
    //       url: `hub/orgs/api/whatsapp-config/templates/list/${payload?.sellerWorkspaceId}?sellerWorkspaceId=${payload?.sellerWorkspaceId}}`,
    //       params: {
    //         wabaId: '518047538061874',
    //         platformFlag: true,
    //         sellerWorkSpaceId: '54916f37-b506-4336-9665-881451817527',
    //         pageNo: 1,
    //         pageSize: 20,
    //       },
    //       method: 'GET',
    //     };
    //   },
    // }),

    TemplatList: builder.mutation<TemplateListResponse, any>({
      query(arg) {
        const { sellerWorkspaceId, payload } = arg;
        return {
          url: `hub/orgs/api/templates/custom/list/${sellerWorkspaceId}?sellerWorkspaceId=${sellerWorkspaceId}`,
          body: payload,
          method: 'POST',
        };
      },
    }),
    TemplatListRefresh: builder.mutation<
      RefreshTemplateResponse,
      RefreshTemplateRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, payload } = arg;
        return {
          url: `hub/orgs/api/whatsapp-config/waba/refresh?sellerWorkspaceId=${sellerWorkspaceId}`,
          body: payload,
          method: 'POST',
        };
      },
    }),
    searchTemplate: builder.mutation<any, any>({
      query(arg) {
        const { sellerWorkspaceId, payload } = arg;
        return {
          url: `hub/orgs/api/whatsapp-config/templates/list/${sellerWorkspaceId}?sellerWorkspaceId=${sellerWorkspaceId}`,
          body: payload,
          method: 'POST',
        };
      },
    }),
    deleteTemplate: builder.mutation<any, any>({
      query(arg) {
        const { sellerWorkspaceId, payload } = arg;
        return {
          url: `hub/orgs/api/templates/custom/delete/${sellerWorkspaceId}?sellerWorkspaceId=${sellerWorkspaceId}`,
          body: payload,
          method: 'POST',
        };
      },
    }),
    templateRefresh: builder.query<any, any>({
      query(arg) {
        const { sellerWorkspaceId, body } = arg;
        return {
          url: `hub/orgs/api/templates/custom/refresh/${sellerWorkspaceId}?sellerWorkspaceId=${sellerWorkspaceId}`,
          body: body,
          method: 'GET',
        };
      },
    }),
    templateCustom: builder.mutation<any, any>({
      query(arg) {
        const { sellerWorkspaceId, payload } = arg;
        return {
          url: `hub/orgs/api/templates/custom/${sellerWorkspaceId}`,
          params: {
            sellerWorkspaceId: sellerWorkspaceId,
          },
          body: payload,
          method: 'POST',
        };
      },
    }),
    defaultTemplatePlatformUpdate: builder.mutation<any, any>({
      query(arg) {
        const { sellerWorkspaceId, payload } = arg;
        return {
          url: `hub/orgs/api/templates/platform/update/${sellerWorkspaceId}`,
          method: 'POST',
          body: payload, // payload should be { jsonData: "<stringified-json>" }
        };
      },
    }),
    getTemplateWithId: builder.query<any, any>({
      query(arg) {
        const { sellerWorkspaceId, templateId } = arg;
        return {
          url: `hub/orgs/api/templates/custom/waba-template/${templateId}`,
          params: {
            sellerWorkspaceId: sellerWorkspaceId,
          },
          method: 'GET',
        };
      },
    }),
    getConsumptionReport: builder.query<
      ConsumptionMetricResponse,
      consumptionReportRequest
    >({
      query(arg) {
        return {
          url: `hub/reports/api/v1/consumption-report/${arg?.sellerWorkspaceId}`,
          params: arg,
          method: 'GET',
        };
      },
    }),

    getTurnoverConfig: builder.query<
      ConfigDetailsResponse,
      { workspaceId: string; sellerWorkspaceId?: string }
    >({
      query(arg) {
        return {
          url: `configsettings/config`,
          params: {
            workspaceId: arg.workspaceId,
            module: ConfigModule.TURNOVER,
            rollback: false,
            ...(arg.sellerWorkspaceId && {
              sellerWorkspaceId: arg.sellerWorkspaceId,
            }),
          },
          method: 'GET',
          cache: 'no-cache',
        };
      },
      transformResponse: (response: ConfigDetailsResponse) => {
        const config = response.config;
        const transformedConfig = Object.fromEntries(
          Object.entries(config).map(([key, value]) => [
            key,
            value === 'true' ? true : value === 'false' ? false : value,
          ])
        );
        return { ...response, config: transformedConfig };
      },
    }),

    getShippingChargesList: builder.query<
      GetShippingChargesListResponse,
      GetShippingChargesListRequest
    >({
      query(arg) {
        return {
          url: `hub/commerce-v2/shipping-methods/${arg?.sellerWorkspaceId}`,
          params: arg,
          method: 'GET',
        };
      },
    }),

    getShippingChargesById: builder.query<
      GetShippingChargesByIdResponse,
      GetShippingChargesByIdRequest
    >({
      query(arg) {
        return {
          url: `hub/commerce-v2/shipping-methods/${arg?.sellerWorkspaceId}/${arg?.shippingMethodId}`,
          params: { sellerWorkspaceId: arg?.sellerWorkspaceId },
          method: 'GET',
        };
      },
    }),

    createShippingCharges: builder.mutation<any, CreateShippingChargesRequest>({
      query(arg) {
        return {
          url: `hub/commerce-v2/shipping-methods/${arg?.params?.sellerWorkspaceId}`,
          params: arg?.params,
          body: arg?.body,
          method: 'POST',
        };
      },
    }),

    updateShippingCharges: builder.mutation<any, CreateShippingChargesRequest>({
      query(arg) {
        return {
          url: `hub/commerce-v2/shipping-methods/${arg?.params?.sellerWorkspaceId}/${arg?.shippingId}`,
          params: arg?.params,
          body: arg?.body,
          method: 'PUT',
        };
      },
    }),

    deleteShippingCharges: builder.mutation<
      { result: string },
      DeleteShippingChargesRequest
    >({
      query(arg) {
        return {
          url: `hub/commerce-v2/shipping-methods/${arg?.sellerWorkspaceId}/${arg?.shippingMethodId}`,
          params: { sellerWorkspaceId: arg?.sellerWorkspaceId },
          method: 'DELETE',
        };
      },
    }),

    updateSequenceOfShippingCharges: builder.mutation<
      any,
      UpdateSequenceOfShippingChargesRequest
    >({
      query(arg) {
        return {
          url: `hub/commerce-v2/shipping-methods/update-sequence/${arg?.params?.sellerWorkspaceId}`,
          params: arg?.params,
          body: arg?.body,
          method: 'POST',
        };
      },
    }),

    updateAdvancePayment: builder.mutation<
      UpdateAdvancePaymentResponse,
      UpdateAdvancePaymentRequest
    >({
      query(arg) {
        return {
          url: `/configsettings/create`,
          body: arg,
          method: 'POST',
        };
      },
    }),
  }),
});

export const {
  useConfigSummaryMutation,
  useCreateConfigSettingsMutation,
  useLazyGetConfigDetailsQuery,
  useLazyGetConfigSchemaQuery,
  useTemplatListMutation,
  useTemplateCustomMutation,
  useDeleteTemplateMutation,
  useSearchTemplateMutation,
  useLazyTemplateRefreshQuery,
  useLazyGetTemplateWithIdQuery,
  useLazyGetConsumptionReportQuery,
  useTemplatListRefreshMutation,
  useLazyGetTurnoverConfigQuery,
  useCreateShippingChargesMutation,
  useLazyGetShippingChargesListQuery,
  useLazyGetShippingChargesByIdQuery,
  useDefaultTemplatePlatformUpdateMutation,
  useUpdateShippingChargesMutation,
  useDeleteShippingChargesMutation,
  useUpdateSequenceOfShippingChargesMutation,
  useUpdateMMLiteMutation,
  useUpdateAdvancePaymentMutation,
} = configApi;
